import { render } from "./InputType.vue?vue&type=template&id=e9dd0fec"
import script from "./InputType.vue?vue&type=script&lang=js"
export * from "./InputType.vue?vue&type=script&lang=js"
script.render = render

export default script